import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Clinic } from '../../../../apis/clinics/types';
import * as clinicsApi from '../../../../apis/clinics/requests';

type UpdateClinicProps = [string, Partial<Clinic>];

const useUpdateClinic = () => {
  const client = useQueryClient();

  const mutation = useMutation({
    mutationFn: ([clinicId, clinic]: UpdateClinicProps) => {
      return clinicsApi.updateClinic(clinicId, clinic);
    },
    onSuccess: (_, [clinicId]) => {
      client.removeQueries(['clinic', clinicId]);
    }
  });

  const { mutateAsync: updateClinic, isLoading } = mutation;

  return { updateClinic, isLoading };
};

export default useUpdateClinic;
